import parseUserAccessories from './parse/parseUserAccessories'
import parseUserAvatars from './parse/parseUserAvatars'
import parseUserClaimables from './parse/parseUserClaimables'

/**
 * Parse the user data
 *
 * @param {object} props - the input props
 * @returns {object} the parsed data
 */
export default function parseUserData (props) {
  const {
    categoryConfig,
    nftData,
    specialOffersData,
    storeData,
    utilityConfig
  } = props
  const { elements: elementsKeys } = storeData

  const avatars = parseUserAvatars({
    avatars: nftData?.avatars || [],
    elementsKeys,
    categoryConfig
  })

  const {
    allAccessories,
    attachedAccessories,
    countAllAccessories,
    detachedAccessories
  } = parseUserAccessories({
    avatars: nftData?.avatars || [],
    accessories: nftData?.accessories || [],
    elementsKeys,
    categoryConfig
  })

  const { claimable, claimed, countClaimable, countClaimed } =
    parseUserClaimables({
      claimable: nftData?.claimable || [],
      claimed: nftData?.claimed || [],
      utilityConfig
    })

  return {
    avatars,
    countAllAccessories,
    allAccessories,
    attachedAccessories,
    detachedAccessories,
    claimable,
    claimed,
    countClaimable,
    countClaimed,
    specialOffers: specialOffersData || {
      count: 0,
      items: []
    }
  }
}
